/* eslint-disable no-console */
import { Map as ImmutableMap } from 'immutable';
import { connect, MapDispatchToPropsFunction } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import ManageBinder from 'components/ModalWindows/ManageBinder';
import { BinderFormState } from 'components/ModalWindows/ManageBinder/binderFormReducer';
import { ManageBinderActions, ManageBinderOwnProps } from 'components/ModalWindows/ManageBinder/models';
import { ModalType, PdfPageOrder, UploadProjectType } from 'const';
import { hideModal, showModal } from 'containers/ModalManager/actions';
import { modalWindowOptions } from 'containers/ModalManager/selectors';
import { createBinderAndUpload } from 'containers/Project/actions';
import { UploadContextOptions } from 'models';
import { StateMap } from 'models/state';

type ImmutableUploadContext = ImmutableMap<string, UploadProjectType | PdfPageOrder | boolean> & {
  toJS(): UploadContextOptions;
};

type ImmutableModalOptions = ImmutableMap<string, ImmutableUploadContext | boolean | string | number>;

const mapStateToProps = (_: StateMap, props: ManageBinderOwnProps): ReturnType<typeof createStructuredSelector> => createStructuredSelector({
  options: modalWindowOptions(props.modalWindowId),
});

const mapDispatchToProps: MapDispatchToPropsFunction<ManageBinderActions, ManageBinderOwnProps> = (dispatch, props) => ({
  hideModal: (): void => {
    dispatch(hideModal(props.modalWindowId));
  },
  showUploadProjectModal: (): void => {
    dispatch(hideModal(props.modalWindowId));
    dispatch(showModal(ModalType.UPLOAD_PROJECT));
  },
  createBinderAndUpload: (
    binderForm: BinderFormState,
    uploadProjectType: UploadProjectType,
    translationComplete: boolean,
    pdfPageOrder?: PdfPageOrder,
  ): void => {
    dispatch(createBinderAndUpload(binderForm, uploadProjectType, translationComplete, pdfPageOrder));
  },
});

interface StateProps {
  options?: ImmutableModalOptions;
}

type DispatchProps = ManageBinderActions;

const mergeProps = (
  stateProps: StateProps,
  dispatchProps: DispatchProps,
  ownProps: ManageBinderOwnProps,
): StateProps & DispatchProps & ManageBinderOwnProps & { uploadContext?: UploadContextOptions } => {
  const { options } = stateProps;

  let uploadContext: UploadContextOptions | undefined;
  try {
    if (options && ImmutableMap.isMap(options)) {
      const uploadContextValue = options.get('uploadContext');
      if (uploadContextValue && ImmutableMap.isMap(uploadContextValue)) {
        const contextObj = (uploadContextValue as ImmutableUploadContext).toJS();
        uploadContext = {
          uploadProjectType: contextObj.uploadProjectType,
          translationComplete: contextObj.translationComplete,
          pdfPageOrder: contextObj.pdfPageOrder,
        };
      }
    }
  } catch (err) {
    console.error('Error extracting uploadContext:', err);
  }

  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    uploadContext,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(ManageBinder);
